import { render, staticRenderFns } from "./Combination.vue?vue&type=template&id=627b583c&scoped=true&"
import script from "./Combination.vue?vue&type=script&lang=js&"
export * from "./Combination.vue?vue&type=script&lang=js&"
import style0 from "./Combination.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Combination.vue?vue&type=style&index=1&id=627b583c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b583c",
  null
  
)

export default component.exports